import addOrUpdateConversationData from './helpers/addOrUpdateConversationData';
import addOrUpdateItemData from './helpers/addOrUpdateItemData';
import { MailListRowDataType, TableView } from 'owa-mail-list-store';
import ConversationType from 'owa-service/lib/contract/ConversationType';
import Item from 'owa-service/lib/contract/Item';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { action } from 'satcheljs/lib/legacy';

/**
 * Adds or updates the row in the tableView
 * This is called whenever a data is fetched from the server and is being stored. This is also called when
 * a rowAdd or rowModified notificaiton occurs
 * @param row to add or update
 * @param tableView to be loaded
 * @param state the AddOrUpdateRowDataState
 */
export default action('addOrUpdateRowData')(function addOrUpdateRowData(
    row: MailListRowDataType,
    tableView: TableView
) {
    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            addOrUpdateConversationData(row as ConversationType, tableView);
            break;

        case ReactListViewType.Message:
            addOrUpdateItemData(row as Item, tableView);
            break;
    }
});
